module.exports = __webpack_public_path__ + "img/basic.819f9611.svg";